import { getPublicBucketUrl } from '@govinity/shared-config';
import type { MenuItem } from '@govinity/ui/components/blocks/navbar/types';
import { Calendar, FilePenLine, FileText, Home, Scale, Users } from 'lucide-react';
import { env } from '@/env.mjs';

export const LOGIN_URL = `${env.NEXT_PUBLIC_USER_API_URL}/auth/login`;

export const getCodeFromPathname = (pathname: string): string | null => {
  return pathname.match(/^\/portal\/([^\/]+)(?:\/.*)?$/)?.[1] || null;
};

export const getMenuItemsFromCode = (code: string | null): MenuItem[] => {
  if (!code) {
    return [];
  }

  return [
    {
      icon: <Home className="h-4 w-4" />,
      title: 'Home',
      url: `/portal/${code}`,
      key: 'home',
    },
    {
      icon: <Users className="h-4 w-4" />,
      title: 'Commission',
      url: `/portal/${code}/commission`,
      key: 'commission',
    },
    {
      icon: <Calendar className="h-4 w-4" />,
      title: 'Meetings',
      url: `/portal/${code}/meetings`,
      key: 'meetings',
    },
    {
      icon: <FilePenLine className="h-4 w-4" />,
      title: 'Boards',
      url: `/portal/${code}/boards`,
      key: 'boards',
    },
    {
      icon: <FileText className="h-4 w-4" />,
      title: 'Topics',
      url: `/portal/${code}/topics`,
      key: 'topics',
    },
    {
      icon: <Scale className="h-4 w-4" />,
      title: 'Official Actions',
      url: `/portal/${code}/actions`,
      key: 'documents',
    },
  ];
};

export const S3_PUBLIC_BUCKET_URL = getPublicBucketUrl(env.NEXT_PUBLIC_APP_ENV);
